export type PlayerState = "idle" | "loading" | "waiting" | "playing" | "autoplay-blocked" | "error";

export interface LevelInfo {
  index: number;
  height: number;
  bitrate: number;
}

export interface BitrateDataPoint {
  time: number;
  bitrate: number;
  ewma: number;
  level: number;
}

export interface DebugStats {
  droppedFrames: number;
  bandwidthEstimate: number;
  bufferStalledErrors: number;
  fragLoadErrors: number;
  currentLevel: number;
  levels: LevelInfo[];
  bitrateHistory: BitrateDataPoint[];
  // Safari-specific
  stallCount?: number;
}

export interface PlayerCallbacks {
  onStateChange: (state: PlayerState) => void;
  onError: (message: string) => void;
  onAspectRatioDetected: (ratio: "landscape" | "portrait") => void;
  onStreamEnded: () => void;
  onWaitForStream: () => void;
  getStreamUrl: () => string;
}

export interface PlayerInstance {
  setup(): void;
  cleanup(): void;
  getDebugStats(): DebugStats;
  safePlay(): Promise<void>;
}

export function createEmptyDebugStats(): DebugStats {
  return {
    droppedFrames: 0,
    bandwidthEstimate: 0,
    bufferStalledErrors: 0,
    fragLoadErrors: 0,
    currentLevel: -1,
    levels: [],
    bitrateHistory: [],
    stallCount: 0,
  };
}
